import React from "react";

export type ActionIconName = "delete" | "edit" | "markRead";

interface ActionIconProps {
  name: ActionIconName;
}

function ActionIcon({ name }: ActionIconProps) {
  return (
    <svg className="ui-action-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {name === "edit" ? (
        <>
          <path d="M12 20h9" />
          <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4Z" />
          <path d="m15 5 3 3" />
        </>
      ) : null}
      {name === "delete" ? (
        <>
          <path d="M3 6h18" />
          <path d="M8 6V4h8v2" />
          <path d="m19 6-1 14H6L5 6" />
          <path d="M10 11v5M14 11v5" />
        </>
      ) : null}
      {name === "markRead" ? <path d="m4 12 5 5L20 6" /> : null}
    </svg>
  );
}

export default ActionIcon;
